module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-blue-c2470daa78866931dfdf0ba81d97f0e7.svg";